<template>
	<div class="fondoModal" v-if="anunciante">
		<div>
			<div>
				<div class="card text-left">
					<div class="card-header bg-info text-white">
						Editando: {{ anunciante.nombre || 'Nuevo anunciante'}}
						<button type="button" class="close" @click="cerrar">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div style="background-color: #f0f0f0;padding:10px;">
						<div class="row">
							<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6" style="margin-bottom:15px;">
								<div class="input-group input-group-sm has-error" v-if="!anunciante.agente.ID">
									<div class="input-group-addon">
										Agente
									</div>
									<input-query input-class="form-control form-control-sm" :realtime="true" url="gestion-anunciantes/php/api/buscaAgente.php" placeholder="Selecciona el agente" @selected="setAgente($event)"></input-query>
								</div>
								<div style="position:relative;display:block;" v-if="anunciante.agente.ID">
									<img :src="anunciante.agente.avatar" alt="" style="vertical-align:middle;margin:5px;width:50px;height:50px;border-radius:25px;">
									{{ anunciante.agente.nombre }}
									<button class="btn btn-sm btn-danger" style="position:absolute;display:block;right:10px;top:15px;" @click="setAgente(null)" v-if="permisos.anunciantes_crearTodos">
										<span class="fa fa-trash"></span>
									</button>
								</div>
							</div>
							<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
								<div class="input-group input-group-sm" :class="(!anunciante.nombre) ? 'has-error' : 'has-success'">
									<div class="input-group-prepend">
										<span class="input-group-text">
											Anunciante
										</span>
									</div>
									<input type="text" class="form-control form-control-sm" v-model="anunciante.nombre" placeholder="Nombre del anunciante">
								</div>
								<div class="input-group input-group-sm mt-2">
									<div class="input-group-prepend">
										<div class="input-group-text">Categoría</div>
									</div>
									<input-query placeholder="Asigna una o más categorías (escribe % para un listado completo)" url="gestion-anunciantes/php/api/buscaCategoria.php" :realtime="true" inputClass="form-control form-control-sm" @selected="addCategoria($event)" />
								</div>
								<ul class="listaCategorias" v-if="anunciante.categorias.length > 0">
									<li v-for="cat in anunciante.categorias">
										<span>
											<span class="fa fa-tag mr-2"></span>
											{{cat.CodigoSector}} {{cat.SectorDescripcion}} > {{cat.CodigoCategoria}} {{cat.CategoriaDescripcion}}
										</span>
										<span>
											<button class="btn btn-sm btn-danger" @click="delCategoria(cat.CategoriaID)">
												<span class="fa fa-trash"></span>
											</button>
										</span>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="card-body">
						<div style="font-size:1.5em;font-weight:bold;" class="text-info">
							Datos de contacto
						</div>
						<div class="row">
							<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
								<div class="card mb-2" v-for="(direccion, index) in anunciante.direcciones" :key="index">
									<div class="card-body">
										<b>Dirección</b>
										<button class="pull-right btn btn-sm btn-danger" v-if="anunciante.direcciones.length > 1" @click="anunciante.direcciones.splice(index, 1)">
											<span class="fa fa-trash"></span>
										</button>
										<div class="row" style="margin-top:15px;">
											<div class="col-sm-6">
												<div class="input-group input-group-sm">
													<div class="input-group-prepend">
														<span class="input-group-text">
															País
														</span>
													</div>
													<input type="text" class="form-control input-sm" placeholder="País" v-model="direccion.pais">
												</div>
											</div>
											<div class="col-sm-6">
												<div class="input-group input-group-sm">
													<div class="input-group-prepend">
														<span class="input-group-text">
															Comunidad
														</span>
													</div>
													<input type="text" class="form-control input-sm" placeholder="Comunidad" v-model="direccion.region">
												</div>
											</div>
										</div>

										<div class="row" style="margin-top:15px;">
											<div class="col-sm-6">
												<div class="input-group input-group-sm">
													<div class="input-group-prepend">
														<span class="input-group-text">
															Provincia
														</span>
													</div>
													<input type="text" class="form-control input-sm" placeholder="Provincia" v-model="direccion.provincia">
												</div>
											</div>
											<div class="col-sm-6">
												<div class="input-group input-group-sm">
													<div class="input-group-prepend">
														<span class="input-group-text">
															Localidad
														</span>
													</div>
													<input type="text" class="form-control input-sm" placeholder="Localidad" v-model="direccion.localidad">
												</div>
											</div>
										</div>

										<div class="row" style="margin-top:15px;">
											<div class="col-sm-8">
												<div class="input-group input-group-sm">
													<div class="input-group-prepend">
														<span class="input-group-text">
															Vía
														</span>
													</div>
													<input type="text" class="form-control input-sm" v-model="direccion.via" placeholder="Calle Mayor">
												</div>
											</div>
											<div class="col-sm-4">
												<div class="input-group input-group-sm">
													<div class="input-group-prepend">
														<span class="input-group-text">
															C.P.
														</span>
													</div>
													<input type="text" class="form-control input-sm" placeholder="C.P." v-model="direccion.cp">
												</div>
											</div>
										</div>

										<div class="row" style="margin-top:15px;">
											<div class="col-sm-3">
												<div class="input-group input-group-sm">
													<div class="input-group-prepend">
														<span class="input-group-text">
															Nº
														</span>
													</div>
													<input type="text" class="form-control input-sm" placeholder="nº" v-model="direccion.numero">
												</div>
											</div>
											<div class="col-sm-3">
												<div class="input-group input-group-sm">
													<div class="input-group-prepend">
														<span class="input-group-text">
															Esc
														</span>
													</div>
													<input type="text" class="form-control input-sm" placeholder="esc" v-model="direccion.esc">
												</div>
											</div>
											<div class="col-sm-3">
												<div class="input-group input-group-sm">
													<div class="input-group-prepend">
														<span class="input-group-text">
															Piso
														</span>
													</div>
													<input type="text" class="form-control input-sm" v-model="direccion.piso">
												</div>
											</div>
											<div class="col-sm-3">
												<div class="input-group input-group-sm">
													<div class="input-group-prepend">
														<span class="input-group-text">
															Puerta
														</span>
													</div>
													<input type="text" class="form-control input-sm" v-model="direccion.puerta">
												</div>
											</div>
										</div>

										<div class="form-group" style="margin-top:10px;">
											<label for="">Indicaciones extra</label>
											<textarea name="" class="form-control" rows="5" v-model="direccion.indicaciones"></textarea>
										</div>
									</div>
								</div>
								<button class="btn btn-sm btn-success mt-2" @click="addDireccion">
									<span class="fa fa-plus"></span>
									Añadir dirección
								</button>
							</div>
							<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
								<div class="card card-success">
									<div class="card-body">
										<b>Teléfono(s) | E-mail(s)</b>

										<div class="input-group input-group-sm" v-for="(tel, index) in anunciante.telefonos" :key="index" style="margin-top:5px;">
											<div class="input-group-prepend">
												<span class="input-group-text fa fa-phone"></span>
											</div>
											<input type="text" class="form-control input-sm" placeholder="Teléfono" v-model="anunciante.telefonos[index].telefono">
											<div class="input-group-append">
												<button class="btn btn-danger btn-sm" @click="quitaTel(index)">
													<span class="fa fa-trash"></span>
												</button>
											</div>
										</div>

										<div class="input-group input-group-sm" v-for="(tel, index) in anunciante.emails" :key="index" style="margin-top:5px;">
											<div class="input-group-prepend">
												<span class="input-group-text fa fa-w fa-envelope"></span>
											</div>
											<input type="text" class="form-control input-sm" placeholder="E-mail" v-model="anunciante.emails[index].email">
											<div class="input-group-append">
												<button class="btn btn-danger btn-sm" @click="quitaEmail(index)">
													<span class="fa fa-trash"></span>
												</button>
											</div>
										</div>
									</div>
									<div class="card-footer">
										<button class="btn btn-sm btn-success" @click="addTel()">
											<span class="fa fa-plus"></span>
											Teléfono
										</button>

										<button class="btn btn-sm btn-success" @click="addEmail()">
											<span class="fa fa-plus"></span>
											E-mail
										</button>
									</div>
								</div>

								<div class="card card-info mt-2">
									<div class="card-body">
										<b>Ficheros</b>
										<div class="alert alert-info">
											Aquí puedes ajuntar todos los ficheros que sean relevantes para la ficha del anunciante, tales como logotipos, sintonías propias, voces insitucionales personalizadas, etc.
										</div>
									</div>
									<div class="table-responsive" v-if="anunciante.ficheros.length > 0">
										<table class="table table-striped table-condensed">
											<thead>
												<tr>
													<td>Nombre</td>
													<td>Tamaño</td>
													<td>
														<span class="fa fa-gear"></span>
													</td>
												</tr>
											</thead>
											<tbody>
												<tr v-for="fichero in anunciante.ficheros" :key="fichero.nombre">
													<td>{{ fichero.nombre }}</td>
													<td>{{ Math.round(fichero.tamano / 1024)}} kb</td>
													<td>
														<button class="btn btn-sm btn-primary" @click="descargar(fichero.ID_fichero)">
															<span class="fa fa-download"></span>
														</button>
														<button class="btn btn-sm btn-danger" @click="quitarFichero(fichero.ID_fichero)">
															<span class="fa fa-trash"></span>
														</button>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="card-footer">
										<button class="btn btn-sm btn-success" @click="doUpload">
											<span class="fa fa-upload"></span>
											Subir ficheros
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="card-footer">
						<button class="btn btn-primary btn-sm" @click="guardar">
							Guardar
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import { mapGetters } from 'vuex'
import API from '../../services/api'

export default {
	name: 'editor-anunciante',
	props: ['idAnunciante'],

	watch: {
		idAnunciante: function (val) {
			if (val === 'nuevo') {
				// Generamos un nuevo objeto de tipo anunciante
				this.nuevo()
			} else {
				// Cargamos el anunciante
				API.getAnunciante(val)
					.then(res => {
						this.anunciante = res.data.anunciante
					})
					.catch(e => {
						this.$store.commit('alertas/alert', {
							titulo: 'Error',
							mensaje: 'Error obteniendo el anunciante'
						})
					})
			}
		}
	},

	computed: {
		...mapGetters({
			usuario: 'session/usuario',
			permisos: 'permisos/permisos'
		})
	},

	created () {
		if (this.idAnunciante === 'nuevo') {
			// Generamos un nuevo objeto de tipo anunciante
			this.nuevo()
		} else {
			// Cargamos el anunciante
			API.getAnunciante(this.idAnunciante)
				.then(res => {
					this.anunciante = res.data.anunciante
				})
				.catch(e => {
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: 'Error obteniendo el anunciante'
					})
				})
		}
	},

	data: function () {
		return {
			anunciante: null
		}
	},

	methods: {
		nuevo () {
			this.anunciante = {
				ID: null,
				nombre: '',
				agente: {
					ID: null,
					nombre: null,
					avatar: null
				},
				activo: true,
				telefonos: [],
				emails: [],
				direcciones: [{
					pais: 'España',
					region: 'Comunidad Valenciana',
					provincia: 'Castellón',
					via: null,
					numero: null,
					esc: null,
					piso: null,
					puerta: null,
					cp: null,
					indicaciones: null
				}],
				ficheros: [],
				anotaciones: null,
				categorias: []
			}

			if (!this.permisos['anunciantes-crearTodos']) {
				this.anunciante.agente.ID = this.usuario.ID
				this.anunciante.agente.nombre = this.usuario.nombre
				this.anunciante.agente.avatar = this.usuario.avatar
			}
		},

		setAgente (datos) {
			if (!this.permisos.anunciantes_crearTodos) {
				return
			}
			if (!datos) {
				this.anunciante.agente.ID = null
				this.anunciante.agente.nombre = null
				this.anunciante.agente.avatar = null
			} else {
				this.anunciante.agente.ID = datos.datos.ID
				this.anunciante.agente.nombre = datos.datos.nombre
				this.anunciante.agente.avatar = datos.datos.avatar
			}
		},

		addCategoria (d) {
			for (let i = 0; i < this.anunciante.categorias.length; i++) {
				if (this.anunciante.categorias[i].CategoriaID === d.datos.CategoriaID) {
					return
				}
			}

			this.anunciante.categorias.push(d.datos)
		},

		delCategoria (CategoriaID) {
			this.anunciante.categorias = this.anunciante.categorias.filter(c => c.CategoriaID !== CategoriaID)
		},

		addTel () {
			this.anunciante.telefonos.push({
				ID_telefono: null,
				telefono: null,
				nombre: null
			})
		},
		quitaTel (i) {
			this.anunciante.telefonos.splice(i, 1)
		},

		addEmail () {
			this.anunciante.emails.push({
				ID_email: null,
				email: null,
				nombre: null
			})
		},

		addDireccion () {
			this.anunciante.direcciones.push({
				ID_direccion: null,
				pais: 'España',
				region: 'Comunidad Valenciana',
				provincia: 'Castellón',
				via: null,
				numero: null,
				esc: null,
				piso: null,
				puerta: null,
				cp: null,
				indicaciones: null
			})
		},

		quitaEmail (i) {
			this.anunciante.emails.splice(i, 1)
		},

		quitarFichero (idFichero) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar fichero',
				mensaje: '¿Quieres eliminar este fichero?\nEsta acción no se podrá deshacer',
				callback: (acepta) => {
					if (!acepta) {
						return
					}

					const datos = {
						ID_anunciante: this.anunciante.ID_anunciante,
						ID_fichero: idFichero
					}

					API.delFichero(datos)
						.then(res => {
							this.anunciante = res.data.anunciante
						})
						.catch(e => {
							this.$store.commit('alertas/alert', {
								titulo: 'Error',
								mensaje: 'Error eliminando el fichero'
							})
						})
				}
			})
		},

		doUpload () {
			// creamos el input
			const inp = document.createElement('input')
			inp.setAttribute('type', 'file')
			inp.setAttribute('multiple', 'true')
			inp.name = 'ficheros'

			// Vigilamos el evento change
			inp.addEventListener('change', (ev) => {
				const form = new FormData()
				form.append('ID_anunciante', this.anunciante.ID_anunciante)
				for (let i = 0; i < ev.srcElement.files.length; i++) {
					form.append('fichero[]', ev.srcElement.files[i])
				}

				API.setFichero(form)
					.then(res => {
						inp.parentNode.removeChild(inp)
						this.anunciante = res.data.anunciante
					})
					.catch(e => {
						this.$store.commit('alertas/alert', {
							titulo: 'Error',
							mensaje: 'Error subiendo el fichero'
						})
						inp.parentNode.removeChild(inp)
					})
			})

			// lo añadimos al dom
			document.body.appendChild(inp)

			// disparamos el evento
			inp.click()
		},

		guardar () {
			if (!this.anunciante.nombre) {
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Por favor escribe el nombre del anunciante'
				})
				return
			}

			if (!this.anunciante.agente.ID) {
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Por favor selecciona el agente'
				})
				return
			}

			if (this.anunciante.categorias.length === 0) {
				this.$error('Error', 'Debes seleccionar al menos una categoría')
				return
			}

			API.setAnunciante(this.anunciante)
				.then(res => {
					this.anunciante = res.data.anunciante
					this.$store.commit('alertas/alert', {
						titulo: 'Guardado',
						mensaje: 'Se han guardado los cambios correctamente'
					})
				})
				.catch(e => {
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: 'Error guardando los cambios'
					})
				})
		},

		descargar (idFichero) {
			document.location.href = '/src/modulos/gestion-anunciantes/php/api/descarga-fichero.php?ID_anunciante=' + this.anunciante.ID_anunciante + '&ID_fichero=' + idFichero
		},

		cerrar () {
			this.nuevo()
			this.$emit('cerrar')
		}
	}
}
</script>


<style>
	.fondoModal {
		position: fixed;
		display: block;
		top:0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0,0,0,0.5);
		z-index: 50;
		overflow: auto;
	}

	.fondoModal > div:first-child {
		position: relative;
		display: block;
		text-align: center;
	}

	.fondoModal > div:first-child > div:first-child {
		position: relative;
		display:inline-block;
		width: 99%;
		min-width: 200px;
		max-width: 1200px;
		margin-top: 50px;
	}

	ul.listaCategorias {
		margin: 0;
		margin-top: 5px;
		border: 1px solid #e0e0e0;
		background-color: white;
		list-style-type: none;
		padding: 5px;
		display: flex;
		flex-direction: column;
		width: 100%;
	}
	ul.listaCategorias > li {
		display: flex;
		flex-direction: row;
		width: 100%;
		margin-top: 2px;
	}

	ul.listaCategorias > li > span {
		flex-grow: 1;
		text-align: left;
		color: #555555;
		font-size: 0.9em;
		align-self: center;
	}

	ul.listaCategorias > li > span:last-of-type {
		text-align: right;
		flex-grow: 0;
		flex-shrink: 0;
		width: 30px;
	}

</style>



// WEBPACK FOOTER //
// src/modulos/gestion-anunciantes/vue/components/editor/editor.vue